import type {
  BackendModule,
  InitOptions,
  ReadCallback,
  Services,
} from "i18next";
import type { SupportedLanguage } from "../config/languages";
import type { Namespace } from "../config/translations";
import { createTranslationLoader } from "../core/TranslationLoader";

/**
 * i18next用のカスタムバックエンドローダー
 */
export class i18nextTranslationLoader implements BackendModule {
  static type = "backend" as const;
  type = "backend" as const;
  private core = createTranslationLoader();

  init(
    _services: Services,
    _backendOptions: object,
    _i18nextOptions: InitOptions,
  ): void {
    // 必要に応じて初期化処理を実装
  }

  /**
   * 翻訳データを読み込む
   */
  async read(
    language: SupportedLanguage,
    namespace: Namespace,
    callback: ReadCallback,
  ): Promise<void> {
    try {
      const result = await this.core.loadTranslation(language, namespace);
      callback(result.error, result.data);
    } catch (error) {
      console.error(
        `Failed to load translation for ${language}/${namespace}:`,
        error,
      );
      callback(
        error instanceof Error ? error : new Error("Unknown error"),
        null,
      );
    }
  }
}
